// extracted by mini-css-extract-plugin
export default {"cover_section":"home-cover_cover_section__bTxG7","logoCover":"home-cover_logoCover__fMsaG","logo":"home-cover_logo__yJdk-","coverImg":"home-cover_coverImg__pSGkP"};